import React from "react";
import styles from "./NotFound.module.css";
import { NotFoundIcon } from "./404";

interface NotFoundProps {
  returnToHomePage: () => void;
}

export const NotFound: React.FC<NotFoundProps> = ({ returnToHomePage }) => {
  return (
    <div className={styles.notFound}>
      <NotFoundIcon width="224" height="263" />
      <p className={styles.notFoundText}>
        <strong>Oops! Page not found.</strong>
        <br />
        The page you’re looking for doesn’t exist or an error occurred.
        <br />
        Please try again later, or if the issue persists, contact support at{" "}
        <a href="mailto:opluchtpost@gmail.com">opluchtpost@gmail.com</a>.
        <br />
        <button onClick={returnToHomePage} className={styles.homeLink}>
          Return to homepage
        </button>{" "}
        &nbsp; or try refreshing the page.
      </p>
    </div>
  );
};
